function camelCase(str) {
  return str.replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, function(match, index) {
    if (+match === 0) return ""; // or if (/\s+/.test(match)) for white spaces
    return index === 0 ? match.toLowerCase() : match.toUpperCase();
  });
}

const languages = {
  js: { label: 'JavaScript', mode: 'javascript' },
  py: { label: 'Python', mode: 'python' },
  clj: { label: 'Clojure', mode: 'clojure' }
}

function fnFromCode (code, inputs) {
  if (!inputs) inputs = []
  const cleanInputs = inputs.map(c => cleanStr(c.key))
  return [`async function(${cleanInputs.join(', ')}) {`, code || '', '}'].join(
    '\n'
  )
}

function cleanStr (str = '') {
  const s = (str && str.length && camelCase(str.replace(/^[^A-Za-z]+/, ''))) || ''
  if (!s.length) return 'p'
  return s
}

const js = fnFromCode

const py = (code = 'pass', inputs) => {
  if (!Array.isArray(inputs)) inputs = []
  const cleanInputs = inputs.map(c => cleanStr(c.key))
  return `def __m__(${cleanInputs.join(', ')}):\n${code}\n`
}

const clj = (code = '', inputs) => {
  if (!Array.isArray(inputs)) inputs = []
  const cleanInputs = inputs.map(c => cleanStr(c.key))
  return `(fn [${cleanInputs.join(' ')}]\n${code}\n)`
}

module.exports.fnFromCode = fnFromCode
module.exports.js = js
module.exports.py = py
module.exports.clj = clj
module.exports.languages = languages
